export function getPagesNum(arrayLength: number, perPage: number) {
  return Math.ceil(arrayLength / perPage);
}
